import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  Box,
  TextField,
  InputAdornment,
  SvgIcon,
  makeStyles,
  Select,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem
} from '@material-ui/core';
import { Search as SearchIcon } from 'react-feather';

const useStyles = makeStyles((theme) => ({
  root: {},
  importButton: {
    marginRight: theme.spacing(1)
  },
  exportButton: {
    marginRight: theme.spacing(1)
  },
  label: {
    backgroundColor: 'white'
  }
}));

const Toolbar = ({
  className,
  busca,
  filtros,
  placeholder,
  ...rest
}) => {
  const classes = useStyles();
  console.log(filtros);
  return (
    <div
      className={clsx(classes.root, className)}
      {...rest}
    >
      <Box mt={3} m={3}>
        <Box maxWidth={500}>
          <TextField
            fullWidth
            onChange={busca}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SvgIcon
                    fontSize="small"
                    color="action"
                  >
                    <SearchIcon />
                  </SvgIcon>
                </InputAdornment>
              )
            }}
            placeholder={placeholder}
            variant="outlined"
          />
          {filtros !== undefined ? filtros.map((filtro) => (
            <FormControl variant={filtro.variant} style={{ marginTop: '15px', marginBottom: '0px' }} fullWidth>
              <InputLabel shrink fullWidth id={filtro.id} className={classes.label} props={{ shrink: true }}>{filtro.placeholder}</InputLabel>
              <Select
                labelId={filtro.id}
                label={filtro.label}
                displayEmpty
                value={filtro.value}
                onChange={filtro.onChange}
                fullWidth
              >
                <MenuItem value="">
                  <em>{filtro.placeholder}</em>
                </MenuItem>
                {filtro.data.map((item) => (
                  <MenuItem value={item.id}>{item.label}</MenuItem>
                ))}
              </Select>
              <FormHelperText>{filtro.dica}</FormHelperText>
            </FormControl>
          )) : <></> }
        </Box>
      </Box>
    </div>
  );
};

Toolbar.propTypes = {
  className: PropTypes.string,
  busca: PropTypes.func
};

export default Toolbar;
